<script lang="ts">
  import Icon from '../../common/components/Icon.svelte';
  import Text from '../../common/components/Text.svelte';

  function getOffersScrollTarget() {
    return (document.querySelector('.bottom-content-special-offers') ||
      document.querySelector('.basket-offer-wrapper') ||
      document.querySelector('.offers-wrapper')) as HTMLElement | null;
  }

  function scrollToSpecialOffers() {
    const offersSection = getOffersScrollTarget();

    if (!offersSection) {
      return;
    }

    const stickyHeaderOffset = 120;

    const targetTop = offersSection.getBoundingClientRect().top + window.scrollY - stickyHeaderOffset;

    window.scrollTo({
      top: Math.max(targetTop, 0),
      behavior: 'smooth',
    });
  }

  function handleKeydown(event: KeyboardEvent) {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      scrollToSpecialOffers();
    }
  }
</script>

<section class="pdp-section-card accordion-section-card special-offers-card">
  <div class="card-header-btn" role="presentation" tabindex="-1" aria-label="Special offers section">
    <section class="card-title">
      <Icon type="primary" desktopSize={36} mobileSize={30} glyph="icon-offer" />
      <section class="title-subtitle">
        <h2><Text key="extra.pdp.special.offers.message" /></h2>
      </section>
    </section>
    <section class="card-title-meta">
      <span
        class="card-title-meta-text"
        role="button"
        tabindex="0"
        aria-label="Check our special offers"
        on:click={scrollToSpecialOffers}
        on:keydown={handleKeydown}
      >
        <Text key="extra.pdp.check.special.offers.message" />
      </span>
    </section>
  </div>
</section>

<style lang="scss">
  @import '../../common/styles/colors.new.scss';

  .pdp-section-card.accordion-section-card.special-offers-card {
    margin: 10px 0;
    padding: 10px 16px;
    background-color: $neutral-light-04;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    justify-content: center;

    @include desktop-max-width {
      margin: 8px 0;
      padding: 10px;
    }

    .card-header-btn {
      padding: 0;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      text-align: left;
      cursor: pointer;
    }

    .card-title {
      display: flex;
      gap: 8px;
      align-items: center;
      min-width: 0;

      h2 {
        padding: 0;
        flex-grow: 1;
        font-size: 16px;
        font-weight: 700;
        line-height: 20px;
        color: $neutral-dark-01;
        margin: 0;

        @include desktop-min-width {
          font-size: 18px;
        }
      }
    }

    .card-title-meta {
      display: flex;
      align-items: center;
      gap: 12px;
      color: $primary-blue;
      flex-shrink: 0;
    }

    .card-title-meta-text {
      color: $primary-blue;
      font-size: 14px;
      line-height: 20px;
      font-weight: 500;
    }
  }

  .special-offers-placeholder {
    padding: 4px 0 0;

    p {
      margin: 0;
      color: $neutral-dark-02;
      font-size: 14px;
      line-height: 20px;
    }
  }
</style>
